import { getDevices } from "../ajax/cloud";
import { getPairedDevices } from "../duck/selectors";
import { updatePairedDevice } from "../duck/actions";

import { updateDevice } from "src/modules/auth/duck/actions";
import { getXmppLogin } from "src/modules/auth/duck/selectors";

function synchronizeDevices() {
  return async function (dispatch, getState) {
    const thisDeviceJid = getXmppLogin(getState());
    const roster = getPairedDevices(getState());
    const newDevices = await getDevices();

    newDevices.forEach((device) => {
      const deviceInRoster = roster[device.xmppLogin]
        ? { ...roster[device.xmppLogin] }
        : null;

      if (!deviceInRoster && device.xmppLogin === thisDeviceJid) {
        dispatch(
          updateDevice({
            name: device.deviceName,
            originalName: device.originalDeviceName,
            color: device.color
          })
        );
      }

      if (!deviceInRoster) return;
      let update = false;

      if (device.originalDeviceName) {
        deviceInRoster.originalName = device.originalDeviceName;
        update = true;
      }
      if (device.color) {
        deviceInRoster.color = device.color;
        update = true;
      }
      if (deviceInRoster.name !== device.deviceName) {
        deviceInRoster.name = device.deviceName;
        update = true;
      }

      if (update) {
        dispatch(updatePairedDevice(deviceInRoster));
      }
    });
  };
}

export { synchronizeDevices as synchronize };
